// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3CLu5","item":"PaymentsMobile_item__3h4UK","label":"PaymentsMobile_label__1ThAS","amount":"PaymentsMobile_amount__2larI"};